<template lang="pug">
.internet-frame(style="width: 500px")
  .internet-header.border-bottom
    pr-subtitle {{ $t("Connect to Wi-Fi") }}
  .internet-status.surface-bg-darker.px-5.py-3.d-flex.align-items-center
    .info.flex-grow-1(v-if="status === false")
      i.fal.fa-wifi-slash.text-warning.mr-3
      span {{  $t("Internet service isn't active.")  }}
    .info.flex-grow-1(v-if="status === true")
      i.fal.fa-wifi.text-success.mr-3
      span {{ $t("Internet service is active now.") }}
    pr-switch(:value.sync="status", xsmall)
  .internet-body.d-flex.align-items-center.flex-column.justify-content-center(v-if="status === true")
    .informations.d-flex.flex-wrap
      .information.d-flex.flex-grow-1.border.py-3.px-3.justify-content-center.m-1
        i.fal.fa-wifi.mr-3
        span {{ ssid }}
      .information.d-flex.flex-grow-1.border.py-3.px-3.justify-content-center.m-1
        i.fal.fa-lock.mr-3
        span {{ password }}
    .qr-header.h5.mt-5 {{ $t("Alternatively, just scan QR code") }}
    .qr-code.mt-4
      .image.bg-white.text-center
        img.qrcode(:src="qrcode", v-if="qrcode")
</template>

<script>
export default {
  name: "internet",
  data() {
    return {
      ssid: null,
      password: null,
      status: null,
      qrcode: null
    }
  },
  watch: {
    status(nval, oval) {
      if (oval === false && nval === true) __.device.enableSoftAP()
      else if (oval === true && nval === false) __.device.disableSoftAP()
    }
  },
  async created() {
    const { ssid, password, status } = await __.device.getSoftAP()

    this.ssid = ssid
    this.password = password
    this.status = status

    this.qrcode = await __.api.get.softap({ ssid, password }).then(res => res?.qr)
  },
  async mounted() {
    this.$emit("ready")
    _$.nav.sync("sideload", true)
  }
}
</script>

<style lang="scss">
.internet-frame {
  height: 100%;
  display: flex;
  flex-direction: column;

  .internet-header {
    padding: 1.5rem 3rem;
    text-align: center;
  }
  .internet-body {
    padding: 0 3rem;
    flex: 1 0 auto;

    img.qrcode {
      width: 300px;
    }
  }
  .information span {
    text-transform: none;
  }
}
</style>
